import React, { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import { Cliente } from "../../services/dashboard/GetClientes";
import { editClient, EditClientPayload } from "../../services/dashboard/EditClient";
import "../../styles/dash/CreateOrEditChatBot.css"; // Reusing styles
import LoadingSpinner from "../utility/LoadingSpinner";

interface Props {
  client: Cliente | null;
  show: boolean;
  onClose: () => void;
  onSave: (updatedClient: Cliente) => void;
}

const ModalEditClient: React.FC<Props> = ({ client, show, onClose, onSave }) => {
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [telefono, setTelefono] = useState("");
  const [status, setStatus] = useState(true);
  
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [animateOut, setAnimateOut] = useState(false);

  useEffect(() => {
    if (client) {
      setNombre(client.nombre);
      setEmail(client.correo);
      setTelefono(client.telefono);
      setStatus(client.status === 1);
    }
  }, [client]);

  const handleClose = () => {
    setAnimateOut(true);
    setTimeout(() => {
      onClose();
      setAnimateOut(false);
      setErrorMessage("");
    }, 300);
  };

  const handleSubmit = async () => {
    if (!client) return;

    // Validations
    if (!nombre.trim() || !email.trim() || !telefono.trim()) {
      setErrorMessage("Todos los campos son obligatorios.");
      return;
    }

    setLoading(true);
    setErrorMessage("");

    try {
      const payload: EditClientPayload = {
        IdUser: client.id,
        Nombre: nombre,
        Email: email,
        Telefono: telefono,
        Status: status ? 1 : 0,
      };

      await editClient(payload);

      const updatedClient: Cliente = {
        ...client,
        nombre,
        correo: email,
        telefono,
        status: status ? 1 : 0,
      };

      onSave(updatedClient);
      handleClose();

    } catch (error: any) {
      setErrorMessage(error.message || "Ocurrió un error al actualizar el cliente.");
    } finally {
      setLoading(false);
    }
  };

  if (!show && !animateOut) return null;

  return (
    <Modal
      show={!animateOut}
      onHide={handleClose}
      centered
      size="lg"
      backdrop="static"
      contentClassName={`chatbot-form-modal ${animateOut ? 'modal-exit' : 'modal-enter'}`}
    >
      <Modal.Header closeButton closeVariant="white" className="border-0" />

      <Modal.Body className="chatbot-form-content">
        <h5 className="form-title text-center mb-4">
          Editar Cliente
        </h5>

        <Form>
          {loading && <LoadingSpinner />}
          <div className="form-grid">
            <div className="form-group">
              <label>Nombre</label>
              <input
                type="text"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                placeholder="Ej: John Doe"
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Ej: cliente@ejemplo.com"
              />
            </div>

            <div className="form-group">
              <label>Teléfono</label>
              <input
                type="text"
                value={telefono}
                onChange={(e) => setTelefono(e.target.value)}
                placeholder="Ej: +123456789"
              />
            </div>

            <div className="form-group switch-group">
              <label>¿Activo?</label>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={status}
                  onChange={() => setStatus(!status)}
                />
                <span className="slider round"></span>
              </label>
            </div>

            <div className="form-group full-width">
              {errorMessage && (
                <div className="error-message">
                  {errorMessage}
                </div>
              )}

              <button
                type="button"
                className="save-button"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "GUARDANDO..." : "GUARDAR CAMBIOS"}
              </button>
            </div>

            <div className="form-group full-width text-center">
              <button
                type="button"
                className="cancel-button"
                onClick={handleClose}
                disabled={loading}
              >
                Cerrar
              </button>
            </div>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ModalEditClient;
